import { render, staticRenderFns } from "./AppSimpleModal.vue?vue&type=template&id=1324c01c&"
import script from "./AppSimpleModal.vue?vue&type=script&lang=js&"
export * from "./AppSimpleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports